module.exports = __webpack_public_path__ + "static/media/gjødsel.f5cf0c04.m4a";